<div class="flex-fill d-flex flex-column">
    <div class="card p-1">
        <div class="d-flex flex-row">
            <div class="d-flex flex-row me-2">
                <div class="d-flex flex-row">
                    <div class="dx-field-label d-flex flex-fill list-box-labels" >Statuses</div>
                    <dx-tag-box
                        class="flex-fill"
                        style="width: 400px"
                        [items]="statusList"
                        [(value)]="filter.selectedStatuses"
                        [showSelectionControls]="true"
                        displayExpr="name"
                        valueExpr="id"
                    ></dx-tag-box>
                </div>
                <div class="d-flex flex-row ms-4">
                    <div class="dx-field-label d-flex flex-fill list-box-labels">Part Types</div>
                    <dx-tag-box
                        class="flex-fill"
                        style="width: 400px"
                        [items]="partTypes"
                        [(value)]="filter.selectedPartTypes"
                        [showSelectionControls]="true"
                        displayExpr="name"
                        valueExpr="id"
                    ></dx-tag-box>
                </div>
            </div>
            <div class="d-flex flex-column ms-2 me-2">
                <div class="d-flex flex-row">
                    <div class="dx-field-label d-flex flex-fill">Start Date</div>
                    <dx-date-box [(value)]="filter.startDate" style="max-width: 150px"></dx-date-box>
                </div>
                <div class="d-flex flex-row mt-1">
                    <div class="dx-field-label d-flex flex-fill">End Date</div>
                    <dx-date-box [(value)]="filter.endDate" style="max-width: 150px"></dx-date-box>
                </div>
            </div>
            <div class="d-flex flex-column">
                <button type="button" accesskey="s" (click)="search()" class="btn btn-success" [disabled]="!filter.startDate || !filter.endDate">Search</button>
                <button type="button" (click)="clear()" class="btn btn-secondary mt-1">Clear</button>
            </div>
        </div>
    </div>

    <div class="d-flex flex-fill">
        <div class="col-sm-7 flex-fill">
            <div *ngIf="groupedParts" class="m-1 grid-fill partsByDate-data-grid">
                <dx-data-grid
                    #dataGrid
                    class="flex-fill"
                    [dataSource]="groupedParts"
                    [showBorders]="true"
                    [columnAutoWidth]="false"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    (onOptionChanged)="onOptionChanged($event)"
                    (onContentReady)="onContentReady($event)"
                    (onCellDblClick)="rowDoubleClick($event)"
                    (onExporting)="onExporting($event)"
                >
                    <dxi-column dataField="partNumber" caption="Part #" width="315" [sortIndex]="0" [sortOrder]="'asc'"></dxi-column>
                    <dxi-column dataField="mfgPartNumber" caption="MfgPart #" width="120"></dxi-column>
                    <dxi-column dataField="statusName" caption="Status" width="60"></dxi-column>
                    <dxi-column dataField="total" caption="Total" width="60"></dxi-column>
                    <dxi-column dataField="last3MonthTotal" caption="Last3Month" width="60"></dxi-column>
                    <dxi-column dataField="last3to6MonthTotal" caption="Last3to6Month" width="60"></dxi-column>
                    <dxi-column dataField="last6to12MonthTotal" caption="Last6to12Month" width="60"></dxi-column>
                    <dxi-column dataField="greaterThan12MonthTotal" caption="GreaterThan12Month" width="60"></dxi-column>
                    <dxi-column></dxi-column>

                    <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                    <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <!-- <dxo-filter-panel [visible]="true"></dxo-filter-panel> -->
                    <dxo-selection [mode]="'multiple'"></dxo-selection>
                    <dxo-sorting mode="multiple"></dxo-sorting>
                    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

                    <div *dxTemplate="let data of 'toolbarButtons'"></div>
                    <div *dxTemplate="let data of 'leadingToolbarText'">
                        <span *ngIf="groupedParts" class="me-3" style="font-size: smaller; font-style: italic; font-weight: 700">{{ '(Double click rows to see details)' }}</span>
                    </div>
                    <div *dxTemplate="let data of 'toolbarText'">
                        <span *ngIf="groupedParts" class="me-3"
                            ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                        >
                    </div>
                </dx-data-grid>
            </div>
        </div>

        <div class="col-sm-5">
            <div *ngIf="groupedParts && partInfos" class="m-1 grid-fill partsByDate-data-grid">
                <dx-data-grid
                    #detailGrid
                    [dataSource]="partInfos"
                    [showBorders]="true"
                    [columnAutoWidth]="false"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    (onOptionChanged)="onOptionChanged($event)"
                    (onContentReady)="onContentReady($event)"
                    (onExporting)="onExporting($event)"
                >
                    <dxi-column dataField="invoiceNumber" caption="SO #" width="100" cellTemplate="linkTemplate"></dxi-column>
                    <dxi-column dataField="companyName" caption="Dealer"></dxi-column>
                    <dxi-column dataField="partNumber" caption="Part #" width="300"></dxi-column>
                    <dxi-column dataField="quantity" caption="Qty" width="80"></dxi-column>
                    <dxi-column dataField="quarter" width="80"></dxi-column>
                    <dxi-column dataField="status" width="180"></dxi-column>
                    <dxi-column dataField="createDate" caption="Sales Order Date" dataType="date" width="180"></dxi-column>

                    <div *dxTemplate="let cell of 'linkTemplate'">
                        <a [routerLink]="[]" (click)="open(cell.data.orderId)">{{ cell.value || '' }}</a>
                    </div>

                    <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                    <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-selection [mode]="'multiple'" showCheckBoxesMode="false"></dxo-selection>
                    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="parts-date-overview-salesOrder-grid"></dxo-state-storing>
                    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <!-- <button type="button" class="btn btn-sm btn-primary me-4" (click)="markAsBackOrdered()" [hidden]="purchaseOrder.statusId !== 3">Mark As BackOrdered</button> -->
                    </div>
                    <div *dxTemplate="let data of 'leadingToolbarText'"></div>
                    <div *dxTemplate="let data of 'toolbarText'">
                        <span *ngIf="partInfos" class="me-3"
                            ><strong>{{ detailGrid.instance.totalCount() + ' items' }}</strong></span
                        >
                    </div>
                </dx-data-grid>
            </div>
        </div>
    </div>
</div>
